module.exports = __webpack_public_path__ + "img/main-banner-mobile-promo.df2d7a0.png";